import CityPageTemplate from "../city-template/CityPageTemplate";
import { charlottesvilleVaConfig } from "./data";

export default function CharlottesvilleVaPage() {
  return <CityPageTemplate config={charlottesvilleVaConfig} />;
}